import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function FocusGrid() {
  const sorted = [...articles].sort((a, b) => b.popularity - a.popularity);
  const lead = sorted[0];
  const secondary = sorted.slice(1, 3);
  const sidebar = sorted.slice(3, 9);
  const hotCategories = categories.map((cat) => ({
    ...cat,
    count: articles.filter((item) => item.category === cat.slug).length,
  }));

  return (
    <section className="mx-auto max-w-[1200px] px-4 pt-14 md:px-8 md:pt-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Featured</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">焦点内容 · 编辑推荐</h2>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-8">
          <Link
            to={`/detail/${lead.id}`}
            className="group relative block aspect-[16/10] overflow-hidden rounded-lg"
          >
            <img
              src={lead.cover}
              alt={`${lead.title} 焦点搭配`}
              title={`${lead.title} - 黑丝时尚搭配`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/25 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                {lead.tags[0]}
              </span>
              <h3 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">{lead.title}</h3>
              <p className="mt-2 line-clamp-2 max-w-2xl text-sm text-background-100/90">{lead.excerpt}</p>
            </div>
          </Link>

          <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
            {secondary.map((item) => (
              <Link key={item.id} to={`/detail/${item.id}`} className="group flex flex-col">
                <div className="aspect-[16/10] overflow-hidden rounded-lg bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.title} 搭配推荐`}
                    title={`${item.title} - 黑丝时尚搭配`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <h4 className="mt-3 line-clamp-2 font-heading text-lg font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h4>
                <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{item.excerpt}</p>
              </Link>
            ))}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="rounded-lg border border-foreground-200/70 bg-background-100 p-5">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-fire-line" />
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">热门推荐</h3>
            </div>
            <div className="no-scrollbar flex max-h-[420px] flex-col gap-3 overflow-y-auto pr-1">
              {sidebar.map((item, i) => (
                <Link key={item.id} to={`/detail/${item.id}`} className="group flex gap-3">
                  <span className="w-4 shrink-0 pt-1 text-center font-heading text-sm font-bold text-primary-500">
                    {i + 1}
                  </span>
                  <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md bg-background-200">
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} - 黑丝时尚搭配`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0">
                    <h4 className="line-clamp-2 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </h4>
                    <span className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-eye-line" /> {item.popularity}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="mt-6 rounded-lg border border-foreground-200/70 bg-background-100 p-5">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-price-tag-3-line" />
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">热门分类</h3>
            </div>
            <div className="flex flex-col gap-2">
              {hotCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/categories?cat=${cat.slug}`}
                  className="flex items-center justify-between rounded-md bg-background-50 px-4 py-3 text-sm text-foreground-800 transition-colors hover:bg-secondary-100"
                >
                  <span>{cat.name}</span>
                  <span className="text-xs text-foreground-500">{cat.count} 篇</span>
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}